<template>
    <DeliveryRequestDetail
        :delivery="delivery"
        :show="show"
        :show-update-button="hasCompanyRole"
        :show-update-modal="showUpdateModal"
        :show-change-request-modal="showChangeRequestModal"
        @updateDeliveryRequest="updateRequest"
        @submitChangeRequest="submitChangeRequest"
        @update:show="$emit('update:show', $event)"
        @update:showUpdateModal="showUpdateModal = $event"
        @update:showChangeRequestModal="showChangeRequestModal = $event"
    />
</template>
<script>
import { mapActions } from "vuex";
import swal from "sweetalert2";
import DeliveryRequestDetail from "./_components/DeliveryRequestDetail";
import { getters } from "src/global-store.js";

export default {
    name: "DeliveryRequestDetailModule",
    components: { DeliveryRequestDetail },
    props: {
        delivery: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showUpdateModal: false,
            showChangeRequestModal: false,
            pastDueInvoiceMessage: "",
            numberPastDueInvoices: 0,
            daysPastDue: 0,
            loaded: false,
        };
    },
    computed: {
        hasCompanyRole() {
            return getters.hasCompanyRole();
        },
    },
    methods: {
        ...mapActions("$_deliveryRequest", [
            "updateDeliveryRequest",
            "addChangeRequestForDelivery",
        ]),
        async updateRequest(deliveryRequest) {
            await this.updateDeliveryRequest(deliveryRequest);
            this.showUpdateModal = false;
            swal({
                title: "Success!",
                text: "Delivery request was updated.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success btn-fill",
                type: "success",
            });
        },
        async submitChangeRequest(deliveryRequest) {
            await this.addChangeRequestForDelivery(deliveryRequest);
            this.showChangeRequestModal = false;
            swal({
                title: "Success!",
                text: "Your change request has been received and a confirmation email was sent.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success btn-fill",
                type: "success",
            });
        },
    },
};
</script>
